export default __webpack_public_path__ + "static/lspn-dbc3ba68237bcc5e0f0f0a2f8645b2d4.png";